import styled from '@emotion/styled';

import { Icon, tokens, Tooltip } from '@hotjar/hotsauce';
import { useTranslation } from 'react-i18next';

export const StyledIcon = styled(Icon)`
  color: ${tokens.color.text_danger};
  margin-left: ${tokens.spacer.x1};
  min-width: 12px;
`;

interface Props {
  text?: string;
}

export const SiteLockedIcon = ({ text }: Props): JSX.Element => {
  const { t } = useTranslation();
  return (
    <Tooltip text={text ?? t('billing:site-box.locked-tooltip')}>
      <StyledIcon icon="lock" />
    </Tooltip>
  );
};
